import type { DashboardLinkedEntry } from '../types/dashboard'

export const DASHBOARD_LINKED: DashboardLinkedEntry[] = [
  { name: 'Consolidated Business Dashboards', roleName: 'Business' },
  { name: 'Consolidated Business Dashboards 1', roleName: 'Business' },
  { name: 'Consolidated Business Dashboards 2', roleName: 'Business' },
  { name: 'Consolidated Business Dashboards 3', roleName: 'Business' },
  { name: 'Consolidated Business Dashboards 4', roleName: 'Business' },
  { name: 'Consolidated Office Manager Dashboards', roleName: 'Office Manager' },
  { name: 'Consolidated Team Manager Dashboards', roleName: 'Team Manager' },
  { name: 'Consolidated Individual Dashboards', roleName: 'Individual' },
  { name: 'Consolidated Admin Dashboards', roleName: 'Admin' },
  { name: 'Advisory Dashboard', roleName: '' },
  { name: 'Consolidations & Eliminations Dashboard', roleName: '' },
  { name: 'Family Office Dashboard', roleName: '' },
  { name: 'Xero Benchmarking Dashboards', roleName: '' },
  { name: 'WFM Dashboard - v2', roleName: 'Business' },
  { name: 'RLS Testing Aug 2024', roleName: 'Business' },
  { name: 'FYI Dashboard', roleName: 'Business' },
]
